import { View, Text, StyleSheet, TextInput, TouchableOpacity, ScrollView, Button, Image, Platform, Modal, ActivityIndicator, PixelRatio, Dimensions } from 'react-native'
import React, { useEffect, useState } from 'react'
import { useRoute } from '@react-navigation/native'
import Colours from '../../utils/Colours'
import axios from '../../api/axios'
import { useNavigation } from '@react-navigation/native'
import { useQuery } from '@tanstack/react-query'
import BackArrow from '../../icons/BackArrow'
import ErrorAlertComp from '../../alertComp/ErrorAlertComp'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import SuccessAlertComp from '../../alertComp/SuccessAlertComp'
import EmailIcon2 from '../../icons/EmailIcon2'
import VerifyEmailCode from './VerifyEmailCode'
import NewPasswordSettings from './NewPasswordSettings'
import AppTextInput from '../../utils/ColourThemes/AppTextInput'

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const EnterEmailScreen = ({ hideModal, setShowEmailEntry }) => {

    const [isEmailFocused, setIsEmailFocused] = useState(false);

    const [isUsernameValid, setIsUsernameValid] = useState(true);
    const [successMessasge, setSuccessMessage] = useState('')
    const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false)
    const [isVerifyEmailCodeVisible, setIsVerifyEmailCodeVisible] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [isErrorCompVisible, setIsErrorCompVisible] = useState(false)


    const [email, setEmail] = useState('')
    const [validEmail, setValidEmail] = useState(false)

    const [isLoading, setIsLoading] = useState(false)
    const [buttonActive, setButtonActive] = useState(false)

    const navigate = useNavigation()

    const axiosPrivate = useAxiosPrivate()

    const handleEmailEntry = (text) => {
        //console.log('email', text)
        setEmail(text)
        setValidEmail(validateEmail(text))
    }

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(email)
    }

    const validateEmailForms = () => {
        if (email === '') {
            setIsEmailFocused(true)
        } else if (validEmail === false) {
            setErrorMessage('Enter a valid email address')
            setIsErrorCompVisible(true)
        } else {
            submitEmail_to_db()
        }
    }

    const submitEmail_to_db = async () => {

        setIsLoading(true);

        try {
            const res = await axios.post('/forgotPass/forgotPass', { email });
            //console.log('response', res.data.message);

            if (res.status === 200 || res.status === 201) {
                //console.log('here fhsh')
                setIsVerifyEmailCodeVisible(true)

            } else {
                setErrorMessage('Email verification failed')
                setIsErrorCompVisible(true)
            }
        } catch (error) {
            setErrorMessage(error.response.data.error || error.response.data.message)
            setIsErrorCompVisible(true)
            //console.log(error);
        } finally {
            setIsLoading(false);
        }
    }


    // if (isLoading) {
    //     return (
    //         <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
    //             <ActivityIndicator size={'large'} color={Colours.PRIMARY} />
    //         </View>
    //     )
    // }

    return (
        <View style={styles.createPullFormContainer}>
            <TouchableOpacity
                onPress={hideModal}
                style={styles.backButtonStyle}
            >
                <BackArrow color={Colours.DARKGRAY} />
            </TouchableOpacity>
            <View style={styles.profilePhotoContainer} >
                <EmailIcon2 height={dynamicSpacing(40)} width={dynamicSize(40)} color={Colours.PRIMARY} />
            </View>
            <View style={styles.textAndTxtInput}>
                <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}>
                    Enter your email address registered with us
                </Text>
                <AppTextInput style={[styles.textInputStyle, isEmailFocused && styles.focusedBorder,]}
                    placeholder='Enter email'
                    fontSize={15}
                    keyboardType='email-address'
                    onFocus={() => setIsEmailFocused(true)}
                    onBlur={() => setIsEmailFocused(false)}
                    onChangeText={handleEmailEntry}

                />

            </View>
            <TouchableOpacity style={[styles.buttonGray,
            { backgroundColor: buttonActive ? Colours.DARKGRAY : Colours.PRIMARY }]}
                onPress={() => {
                    setButtonActive(true)
                    validateEmailForms()
                }}
            >
                {isLoading ? (
                    <ActivityIndicator size='small' color='white' />
                ) : (
                    <Text style={{ color: 'white', fontSize: dynamicFontSize(15), fontFamily: 'Sen-Bold' }}>Proceed</Text>
                )
                }
            </TouchableOpacity>

            <Modal
                visible={isErrorCompVisible}
                transparent={true}
                animationType="fade"
                onRequestClose={() => setIsErrorCompVisible(false)}
            >
                <ErrorAlertComp
                    message={errorMessage}
                    onClose={() => setIsErrorCompVisible(false)}
                />
            </Modal>
            <Modal
                visible={isVerifyEmailCodeVisible}
                // transparent={true}
                animationType="fade"
                onRequestClose={() => setIsVerifyEmailCodeVisible(false)}
            >
                <VerifyEmailCode
                    email={email}
                    hideModal={() => {
                        setIsVerifyEmailCodeVisible(false)
                    }}
                    setShowEmailEntry={setShowEmailEntry}
                    setIsVerifyEmailCodeVisible={setIsVerifyEmailCodeVisible}
                />
            </Modal>


        </View>
    )
}

const styles = StyleSheet.create({
    createPullFormContainer: {
        flex: 1, // Use flex: 1 to fill the screen
        paddingTop: dynamicSpacing(20),
        padding: dynamicSpacing(15),
        backgroundColor: 'white',
    },
    backButtonStyle: {
        marginBottom: dynamicSize(60),
    },
    textAndTxtInputRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: dynamicSpacing(15),
    },
    textAndTxtInput: {
        marginTop: dynamicSpacing(15),
    },
    textInputStyle: {
        height: dynamicSpacing(50),
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(15),
        borderWidth: dynamicSize(1.5),
        borderColor: Colours.DARKLIGHTGRAY,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(12),
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    buttonGray: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: dynamicSize(15),
        marginTop: dynamicSpacing(25),
        height: dynamicSpacing(60),
    },
    profilePhotoContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: dynamicSpacing(10),
    },
    userImage: {
        width: dynamicSize(100),
        height: dynamicSize(100),
        borderRadius: dynamicSize(99),
        marginBottom: dynamicSpacing(3),
        borderWidth: dynamicSize(1.5),
        borderColor: Colours.PRIMARY,
        marginTop: dynamicSpacing(10),
        backgroundColor: Colours.LIGHTGRAY,
    },
});


export default EnterEmailScreen
